import React, { useState } from 'react';
import { useStore } from 'react-redux';
import styled from 'styled-components';
import { AppState } from '../../redux/root.reducer';
import { createStandardAxiosInstance } from '../../redux/utils/api.utils';
import { openProtectedDocument } from '../../utils/open-protected-document';
import { P2 } from '../Typography';

const Button = styled.button`
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.primaryBrand};
  cursor: pointer;
  display: inline;
  font-family: ${(props) => props.theme.typography.face.secondary};
  font-size: inherit;
  padding: 0;
  text-align: left;
  text-decoration: underline;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

interface OpenProtectedDocumentButtonProps {
  accessReference?: string;
  children: React.ReactNode;
  errorMessage?: string;
}

export const OpenProtectedDocumentButton = ({
  accessReference,
  children,
  errorMessage = 'Could not open this document. Try again, or sign in again if your session has expired.',
}: OpenProtectedDocumentButtonProps) => {
  const store = useStore<AppState>();
  const [hasError, setHasError] = useState(false);

  const openDocument = async () => {
    if (!accessReference) {
      return;
    }
    const client = createStandardAxiosInstance(store.getState(), store.dispatch);
    try {
      await openProtectedDocument(accessReference, client, (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
      });
      setHasError(false);
    } catch {
      setHasError(true);
    }
  };

  return (
    <>
      <Button
        type="button"
        disabled={!accessReference}
        onClick={() => {
          void openDocument();
        }}
      >
        {children}
      </Button>
      {hasError ? <P2>{errorMessage}</P2> : undefined}
    </>
  );
};
